import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';

import ErrorMessageDialog from './components/ErrorMessageDialog';
import Indicator from './containers/Indicator';
import LoggedInDialog from './containers/LoggedInDialog';
import ErrorHandler from './ErrorHandler';
import { LearnBrowserRouter } from './utils/Routes';

const App: React.FC = () => (
	<div className="App">
		<CssBaseline />
		<ErrorHandler>
			<Indicator />
			<LearnBrowserRouter />
			<ErrorMessageDialog />
			<LoggedInDialog />
		</ErrorHandler>
	</div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx